import React from 'react'
import { connect } from 'react-redux';
import { resetDownload } from '../store/actions';

class DownloadHelper extends React.Component {
  constructor() {
    super();
    this.form = React.createRef();
  }

  shouldComponentUpdate(nextProps) {
    return this.path !== nextProps.path;
  }

  componentDidUpdate() {
    if(this.props.path !== '') {
      this.form.current.submit();
      this.props.resetDownload();
    }
  }

  render() {
    return(
      <div>
        <form ref={this.form} action={this.props.path} target="downloadFrame" method="get" encType="multipart/form-data">
          <input type="hidden" name="fileId" value={this.props.fileId} />
          <input type="hidden" name="packageId" value={this.props.packageId} />
        </form>
        <iframe name="downloadFrame" id="downloadFrame" title="downloadFrame" style={{display: 'none'}} aria-hidden="true"></iframe>
      </div>
    )
  }
}

const mapStateToProps = state => state.download;
const mapDispatchToProps = { resetDownload }

export default connect(mapStateToProps, mapDispatchToProps)(DownloadHelper);